import { Col, Input, Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";

import { ILastNameField } from "./ILastNameField";

import { sizes } from "../../../Assets/Enums";

const LastNameField = ({ lastName, translations, errors, index = 0, handleChangeData, size = "m", disabled = false }: ILastNameField) => (
	<Col xs={24} md={sizes[size]} lg={sizes[size]} >
		<label className="required">
			{translations.firstLastnameSignatory}
			<Tooltip placement="top" title={<span>{translations.signerNameTooltip}</span>}>
				{" "} <InfoCircleOutlined />
			</Tooltip>
		</label>
		<Input
			className="input-field"
			name="lastName"
			value={lastName}
			onChange={handleChangeData(index)}
			placeholder={translations.firstLastnameSignatory}
			disabled={disabled}
			status={
				Array.isArray(errors)
					? (errors[index]?.lastName || errors[index]?.invalidLastNameFormat ? "error" : "")
					: (errors.lastName || errors.invalidLastNameFormat ? "error" : "")
			}
		/>
		<span className={`error ${
			Array.isArray(errors)
				? errors[index]?.lastName ? 'show' : null
				: errors.lastName ? 'show' : null
		}`}>
			{translations.completeCampo}
		</span>
		<span className={`error ${
			Array.isArray(errors)
				? errors[index]?.invalidLastNameFormat ? 'show' : null
				: errors.invalidLastNameFormat ? 'show' : null
		}`}>
			{translations.invalidFormat}
		</span>
	</Col>
);

export default LastNameField;